import { formatTaxRegimesOptions } from '../../DocumentsForm/helpers'
import { HTTP_RESPONSE_STATUS_CODE } from 'utils/constants'
import { showToastAlert } from 'utils/helpers'
import { taxRegimesCatalogsServiceGet } from 'lib/taxRegimes'
import { TFunction } from 'i18next'
import { useEffect, useState } from 'react'

export const useDocumentsForm = (
  t: TFunction
): {
  taxRegimesOptions: {
    label: string
    value: string
  }[]
} => {
  const [taxRegimesOptions, setTaxRegimesOptions] = useState([
    {
      label: '',
      value: ''
    }
  ])

  useEffect(() => {
    taxRegimesCatalogsServiceGet()
      .then(({ data, status }) => {
        if (status === HTTP_RESPONSE_STATUS_CODE['200']) {
          setTaxRegimesOptions(formatTaxRegimesOptions(data))
        } else {
          showToastAlert(t, 'info')
        }
      })
      .catch(() => {
        showToastAlert(t, 'error')
      })
  }, [])

  return {
    taxRegimesOptions
  }
}
